import getTrackDataPayload from 'pages/checkout/helpers/getTrackDataPayload';

import { IBudget } from 'modules/checkout/domain/entities';
import { TPaymentMethodType } from 'shared/domain/entities';
import { PAYMENT_METHOD_TO_API } from 'shared/infra/adapters';

/**
 * Monta o payload dos eventos de compra a partir do orçamento já adaptado.
 *
 * Reaproveita de propósito o montador da tela antiga: esse payload vai para a camada de
 * dados, e um nome de campo diferente quebraria relatório sem quebrar build.
 */
export default function getCheckoutTrackPayload(params: {
  budget: IBudget;
  method: TPaymentMethodType;
  orderId?: number;
  adId?: number;
}) {
  const { budget } = params;
  const { customer } = budget;

  return getTrackDataPayload({
    idAnuncio: params.adId,
    cliente: {
      email: customer.email ?? '',
      foneCelular: customer.phone,
      numeroCep: customer.address?.postalCode,
      nome: customer.firstName,
      sobrenome: customer.lastName,
      cpf: customer.document,
    },
    items: budget.items.map(item => ({ id: item.id, titulo: item.title })),
    formasPagamento: budget.paymentMethods.map(paymentMethod => ({
      key: PAYMENT_METHOD_TO_API[paymentMethod.key],
      precoPor: paymentMethod.values.to,
    })),
    formaPagamento: PAYMENT_METHOD_TO_API[params.method],
    pedido: params.orderId ? { id: params.orderId } : undefined,
  });
}
